export var Account = (function () {
    function Account(account) {
        for (var property in account) {
            this[property] = account[property];
        }
    }
    return Account;
}());
//# sourceMappingURL=account.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/shared/account.js
// module id = 573
// module chunks = 0